import classNames from 'classnames';
import React from 'react';

type AvailableValueTypes = string | number | undefined;

interface ISelectOption<T extends AvailableValueTypes> {
    label: string;
    value: T;
}

interface ISelectFieldProps<T extends AvailableValueTypes> {
    label: string;
    options: ISelectOption<T>[] | [];
    value: T;
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    placeholder?: string;
    error?: string | null;
}

export default function SelectField<T extends AvailableValueTypes>(props: ISelectFieldProps<T>) {
    const { label, options, value, onChange, placeholder, error } = props;

    const baseCssClass = 'bs-form-select-container-component';

    const selectClass = classNames(`${baseCssClass}__select`, {
        [`${baseCssClass}__select--error`]: !!error
    });

    const errorClass = classNames(`${baseCssClass}__error-message`, {
        [`${baseCssClass}__error-message--hidden`]: !error
    });

    return (
        <div className={baseCssClass}>
            <label className={`${baseCssClass}__label`} htmlFor={label}>
                {label}
            </label>

            <select className={selectClass} id={label} value={value || ''} onChange={onChange}>
                {placeholder && (
                    <option value='' disabled>
                        {placeholder}
                    </option>
                )}
                {options.map(opt => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>

            {error && <span className={errorClass}>{error}</span>}
        </div>
    );
}
